import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { document } from '@app/_models/document';
import { headervalue } from 'src/headervalue/header';
import {  Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({ providedIn: 'root' })


export class DocumentService {
  url: string;
  constructor(private http: HttpClient) { }

  getDocument() {
    // this.http.get<document[]>(`${environment.apiUrl}/document/getList`);
    var temp = this.http.get<any>(`${environment.apiUrl}/document/getList`,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }
  
  addDocument(documentParam: document): Observable<document> {
    return this.http.post<document>(`${environment.apiUrl}/document/documentUpload`,documentParam, httpOptions).pipe( );
  }

   deleteDocument(id) {
    return this.http.delete<document>(`${environment.apiUrl}/document/deleteDocumentById/`+id, httpOptions).pipe( );
  }

  updateDocument(documentParam: document): Observable<document> {
    return this.http.post<document>(`${environment.apiUrl}/document/documnetUpdate`,documentParam, httpOptions).pipe( );
  }


}